var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      ref: "dataView",
      attrs: {
        title: "活动数据",
        visible: _vm.visible,
        "append-to-body": true,
        width: "68%",
      },
      on: {
        "update:visible": function ($event) {
          _vm.visible = $event
        },
      },
    },
    [
      _c(
        "el-descriptions",
        { attrs: { column: "3", border: "", size: "mini" } },
        [
          _c("el-descriptions-item", { attrs: { label: "活动名称" } }, [
            _vm._v(_vm._s(_vm.info.activityFirstOrderName)),
          ]),
          _c("el-descriptions-item", { attrs: { label: "隶属公司" } }, [
            _vm._v(_vm._s(_vm.info.merchantName)),
          ]),
          _c("el-descriptions-item", { attrs: { label: "线路" } }, [
            _vm._v(_vm._s(_vm.info.lineName)),
          ]),
          _c("el-descriptions-item", { attrs: { label: "总订单数" } }, [
            _c("span", { staticClass: "tip__color" }, [
              _vm._v(_vm._s(_vm.info.orderNum)),
            ]),
          ]),
          _c("el-descriptions-item", { attrs: { label: "使用优惠数" } }, [
            _c("span", { staticClass: "tip__color" }, [
              _vm._v(_vm._s(_vm.info.firstOrderNum)),
            ]),
          ]),
          _c("el-descriptions-item", { attrs: { label: "使用优惠比例" } }, [
            _c("span", { staticClass: "tip__color" }, [
              _vm._v(_vm._s(_vm.info.ratio)),
            ]),
          ]),
          _c("el-descriptions-item", { attrs: { label: "优惠金额" } }, [
            _c("span", { staticClass: "tip__color" }, [
              _vm._v(_vm._s(_vm.info.firstOrderAmount)),
            ]),
          ]),
          _c("el-descriptions-item", { attrs: { label: "支付金额" } }, [
            _c("span", { staticClass: "tip__color" }, [
              _vm._v(_vm._s(_vm.info.payAmount)),
            ]),
          ]),
        ],
        1
      ),
      _c(
        "div",
        { staticStyle: { "padding-top": "18px" } },
        [
          _c(
            "el-table",
            {
              attrs: {
                load: _vm.loading,
                border: "",
                "max-height": "280px",
                data: _vm.data,
                size: "mini",
              },
            },
            [
              _c("el-table-column", {
                attrs: {
                  label: "用户账号",
                  align: "center",
                  prop: "mobilePhone",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "使用时间",
                  align: "center",
                  prop: "createTime",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "优惠金额",
                  align: "center",
                  prop: "firstOrderAmount",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "支付金额",
                  align: "center",
                  prop: "payAmount",
                },
              }),
              _c("el-table-column", {
                attrs: { label: "订单状态", align: "center", prop: "state" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm._f("stateFilter")(scope.row.state)) +
                            "\n        "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: "使用订单号",
                  align: "center",
                  prop: "orderNo",
                },
              }),
            ],
            1
          ),
          _vm.page.total > 0
            ? _c("pagination", {
                attrs: {
                  total: _vm.page.total,
                  page: _vm.page.current,
                  limit: _vm.page.size,
                },
                on: {
                  "update:page": function ($event) {
                    return _vm.$set(_vm.page, "current", $event)
                  },
                  "update:limit": function ($event) {
                    return _vm.$set(_vm.page, "size", $event)
                  },
                  pagination: _vm.onLoad,
                },
              })
            : _vm._e(),
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            {
              attrs: { size: "small", type: "danger" },
              on: {
                click: function ($event) {
                  _vm.visible = !_vm.visible
                },
              },
            },
            [_vm._v("取 消")]
          ),
          _c(
            "el-button",
            {
              attrs: { type: "primary", size: "small" },
              on: { click: _vm.handleExcel },
            },
            [_vm._v("导出")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }